import "./i18n";
import { ELABEL_VIEW as BASE_ELABEL_VIEW } from "./config/routes";
export const ELABELS_VIEW = {
    ...BASE_ELABEL_VIEW,
};
